import { useState, useEffect } from "react";
import { fetchData } from "../services/api";

const useProgramData = (collectionName, pollingInterval = 30000) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const loadData = async () => {
      try {
        // The backend route is /api/fetch/:collectionName
        const result = await fetchData(`/api/fetch/${collectionName}`);
        if (isMounted) {
          setData(result);
          setLoading(false);
        }
      } catch (err) {
        if (isMounted) {
          setError(err.message || "Failed to load data");
          setLoading(false);
        }
      }
    };

    loadData();

    if (pollingInterval) {
      const intervalId = setInterval(loadData, pollingInterval);
      return () => {
        isMounted = false;
        clearInterval(intervalId);
      };
    }

    return () => {
      isMounted = false;
    };
  }, [collectionName, pollingInterval]);

  const refetch = () => {
    setLoading(true);
    setError(null);
    // This will trigger the useEffect again if we change a dependency, 
    // but typically we want to just force a re-run. 
    // For simplicity with this structure, we can just call the internal logic if we extracted it,
    // but the cleanest React way without refactoring the whole effect 
    // is to toggle a 'version' key or similar.
    // However, since we simply want to expose a way to retry:
    window.location.reload(); // Temporary robust fix until full React Query adoption
  };

  return { data, loading, error, refetch };
};

export default useProgramData;
